export const ordemServicoSituacaoClasses = {
  a_confirmar: "label label-warning",
  questionada: "label label-warning",
  andamento: "label label-warning",
  encerrada: "label label-success",
  aguardando_distribuir: "label label-secondary",
  a_notificar: "label label-warning",
  abertura: "label label-warning",
  reaberto: "label label-warning",
  cancelada: "label label-error",
  reabrindo: "label label-warning",
}

export const ordemServicoComentarioSituacaoTipoClasses = {
  neutro: "label label-secondary",
  irregular: "label label-error",
  solicitou_desconto: "label label-warning",
  regular: "label label-success",
  regular_contribuinte: "label label-success",
  regular_com_desconto: "label label-success",
  cancelado: "label label-warning",
}

export const analiseSituacaoClasses = {
  nenhuma: "label label-dark",
  aguardando: "label label-warning",
  reanalise: "label label-primary",
  reabertura: "label label-dark",
  liberado_definitivo: "label label-success",
  liberado_provisorio: "label label-success",
  nao_liberado: "label label-error",
  cancelado: "label label-error",
}
